import React from 'react';
import classes from './ProductBlock.module.scss';
import apex from '../../assets/images/apex-legends-icon-16.jpg';
import { Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../AppRouter/AppRouter';
import Button from '../UI/Button/Button';
import { useTranslation } from 'react-i18next';

const ProductBlock = ({ id, name, name_lv, imgUrl, region, ...rest }) => {
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();

  const handleClick = () => {
    if (!id) return;
    navigate(
      { pathname: ROUTES.PRODUCT_CARD, search: `?product=${encodeURIComponent(id)}` },
      { state: { product: { id, name, name_lv, imgUrl, region, ...rest } } }
    );
  };

  return (
    <Space
      direction='vertical'
      style={{
        padding: 20,
        borderRadius: 30,
        backgroundColor: '#B8B5B61A',
        width: '100%',
        height: '100%',
        justifyContent: 'space-between'
      }}
      size={20}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          gap: 20
        }}
      >
        <div className={`${classes.container}`}>
          <div className={classes.fade}></div>
          <img
            src={imgUrl || apex}
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = apex;
            }}
            alt=''
          />
        </div>

        <Space direction='vertical' size={10}>
          <h3>{i18n.language === 'en' ? name : name_lv}</h3>
          <Typography
            style={{
              fontSize: 18,
              fontWeight: 700,
              lineHeight: '110%',
              color: '#B8B5B6'
            }}
          >
            {region}
          </Typography>
        </Space>
      </div>
      <Button wide mode='outlined' onClick={handleClick}>
        {t('pages.main.marketplace.buy')}
      </Button>
    </Space>
  );
};

export default ProductBlock;